import React from "react";
import { Tag } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { PurchaseOrderStatus } from "../../../types";

type TagType =
  | "red"
  | "magenta"
  | "purple"
  | "blue"
  | "cyan"
  | "teal"
  | "green"
  | "gray"
  | "cool-gray"
  | "warm-gray";

export const OC_STATUS_TAG_TYPE: Record<PurchaseOrderStatus, TagType> = {
  DRAFT: "cool-gray",
  PENDING_APPROVAL: "warm-gray",
  REJECTED_APPROVER: "red",
  SENT: "blue",
  ACCEPTED: "green",
  REJECTED_SUPPLIER: "red",
  IN_DELIVERY: "teal",
  DELIVERED: "green",
  CANCELLED: "gray",
};

interface OcStatusPillProps {
  status: PurchaseOrderStatus;
}

/** Colored, translated status tag for a purchase order. Never renders the raw enum. */
const OcStatusPill = ({ status }: OcStatusPillProps) => {
  const { t } = useTranslation();
  return (
    <Tag type={OC_STATUS_TAG_TYPE[status]} size="md">
      {t(`purchaseOrders.status.${status}`)}
    </Tag>
  );
};

export default OcStatusPill;
